import React from 'react'

const tabs = [
  { id: 'tools', label: '🤖 常用 AI 网站', color: '#ff4d6d' },
  { id: 'books', label: '📚 AI 书籍推荐', color: '#9f7aea' },
  { id: 'movies', label: '🎬 AI 电影推荐', color: '#68d391' },
  { id: 'online', label: '🎥 视频推荐', color: '#63b3ed' },
  { id: 'books-talk', label: '📖 萝卜讲书', color: '#f6d860' },
  { id: 'videos', label: '📺 联系站长', color: '#63b3ed' },
]

const NavTabs = ({ activeTab, onTabChange }) => {
  return (
    <nav className="nav-tabs">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="tab-dot" style={{ background: tab.color }}></span>
          {tab.label}
        </button>
      ))}
    </nav>
  )
}

export default NavTabs
